import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// IMPORTA AQUÍ TUS IMÁGENES
import donante1 from "../assets/bancoAlimentos.png";
import donante2 from "../assets/logo2.png";
import donante3 from "../assets/logo2.png";
import donante4 from "../assets/logo2.png";
import donante5 from "../assets/logo2.png";

export default function CarrusellDonantes() {
  const imagenes = [
    {
      id: 1,
      imagen: donante1,
      alt: "Donante Fundación Manitas de Colores",
    },
    {
      id: 2,
      imagen: donante2,
      alt: "Donante Fundación Manitas de Colores",
    },
    {
      id: 3,
      imagen: donante3,
      alt: "Donante Fundación Manitas de Colores",
    },
    {
      id: 4,
      imagen: donante4,
      alt: "Donante Fundación Manitas de Colores",
    },
    {
      id: 5,
      imagen: donante5,
      alt: "Donante Fundación Manitas de Colores",
    },
  ];

  const [imagenActual, setImagenActual] = useState(2);

  const siguienteImagen = () => {
    setImagenActual((prev) =>
      prev === imagenes.length - 1 ? 0 : prev + 1
    );
  };

  const anteriorImagen = () => {
    setImagenActual((prev) =>
      prev === 0 ? imagenes.length - 1 : prev - 1
    );
  };

  const obtenerPosicion = (index) => {
    let diferencia = index - imagenActual;

    if (diferencia > imagenes.length / 2) {
      diferencia -= imagenes.length;
    }

    if (diferencia < -imagenes.length / 2) {
      diferencia += imagenes.length;
    }

    return diferencia;
  };

  return (
    <section className="w-full py-14 px-4 overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto">

        {/* Título */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-orange-one">
            Nuestros donantes
          </h2>

          <p className="mt-3 text-gray-600 max-w-2xl mx-auto font-semibold">
            Gracias a todas las personas e instituciones que hacen posible
            seguir transformando vidas.
          </p>
        </div>

        {/* Carrusel */}
        <div className="relative h-[300px] md:h-[360px] flex items-center justify-center">

          {/* Botón izquierda */}
          <button
            onClick={anteriorImagen}
            className="
              absolute
              left-2
              md:left-8
              z-30
              bg-white
              w-11
              h-11
              rounded-full
              shadow-lg
              flex
              items-center
              justify-center
              text-gray-700
              hover:scale-110
              hover:bg-orange-one
              hover:text-white
              transition
              duration-300
            "
            aria-label="Imagen anterior"
          >
            <ChevronLeft size={25} />
          </button>

          {/* Imágenes */}
          <div className="relative w-full h-full flex items-center justify-center">
            {imagenes.map((item, index) => {
              const posicion = obtenerPosicion(index);

              // Solo mostramos las imágenes más cercanas
              if (Math.abs(posicion) > 2) return null;

              const esCentral = posicion === 0;
              const esLateral = Math.abs(posicion) === 1;

              return (
                <div
                  key={item.id}
                  onClick={() => setImagenActual(index)}
                  className="
                    absolute
                    overflow-hidden
                    rounded-xl
                    shadow-xl
                    cursor-pointer
                    transition-all
                    duration-500
                    ease-in-out
                  "
                  style={{
                    transform: `
                      translateX(${posicion * 190}px)
                      scale(${
                        esCentral
                          ? 1
                          : esLateral
                          ? 0.88
                          : 0.75
                      })
                    `,
                    zIndex: esCentral
                      ? 20
                      : esLateral
                      ? 10
                      : 5,

                    opacity:
                      Math.abs(posicion) === 2
                        ? 0.7
                        : 1,
                  }}
                >
                  <img
                    src={item.imagen}
                    alt={item.alt}
                    className="
                      w-[230px]
                      h-[230px]
                      md:w-[280px]
                      md:h-[280px]
                      object-cover
                    "
                  />
                </div>
              );
            })}
          </div>

          {/* Botón derecha */}
          <button
            onClick={siguienteImagen}
            className="
              absolute
              right-2
              md:right-8
              z-30
              bg-white
              w-11
              h-11
              rounded-full
              shadow-lg
              flex
              items-center
              justify-center
              text-gray-700
              hover:scale-110
              hover:bg-orange-one
              hover:text-white
              transition
              duration-300
            "
            aria-label="Siguiente imagen"
          >
            <ChevronRight size={25} />
          </button>
        </div>

        {/* Indicadores inferiores */}
        <div className="flex justify-center gap-2 mt-4">
          {imagenes.map((_, index) => (
            <button
              key={index}
              onClick={() => setImagenActual(index)}
              className={`
                h-2 rounded-full transition-all duration-300
                ${
                  imagenActual === index
                    ? "w-8 bg-orange-one"
                    : "w-2 bg-gray-300"
                }
              `}
              aria-label={`Ir a imagen ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}